import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useAddJobMutation, useEditJobMutation } from "../../redux/services/JobService";
import { useAddTractorMutation, useEditTractorMutation } from "../../redux/services/TractorsService";
import { convertToFormDataDeepCopy, sweetAlert } from "../../utils";
import { responseError } from "../../helpers/responseHandler";
import { FILE_URL } from "../../redux/services/apiConstant";
import LoadingButtonWithForm from "../../components/LoadingButtonWithForm";

export default function CreateAssetModal({ isEdit, handleClose }) {
    const [assetType, setAssetType] = useState("tractors");

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            make: isEdit?.make ?? "",
            model: isEdit?.model ?? "",
            year: isEdit?.year ?? "",
            vin: isEdit?.vin ?? "",
            dot_inspection_expiry: isEdit?.dot_inspection_expiry ?? "",
            cab_card_expiry: isEdit?.cab_card_expiry ?? "",
            notify_me: isEdit?.notify_me ?? 1,
        },
    });

    const [addRequest, { isLoading: addLoading }] = useAddTractorMutation()
    const [editRequest, { isLoading: editLoading }] = useEditTractorMutation()

    const onSubmit = async (data) => {
        data['notify_me'] = data?.notify_me ? 1 : 0
        console.log("Form Submitted:", { assetType, ...data });
        // reset();
        // handleClose();

        if (isEdit) {
            const newForm = convertToFormDataDeepCopy({ type: assetType, ...data })

            await editRequest({ id: isEdit?.id, newForm }).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = convertToFormDataDeepCopy({ type: assetType, ...data })

            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    };
    // 👇 When editing, populate form with existing values
    useEffect(() => {
        if (isEdit?.type) {
            setAssetType(isEdit?.type || "tractors");
        }
    }, [isEdit?.type]);

    // Define fields dynamically for each asset type
    const formFields = {
        tractors: [
            { name: "make", placeholder: "Make", type: "text", required: true },
            { name: "model", placeholder: "Model", type: "text", required: true },
            { name: "year", placeholder: "Year", type: "number", required: true },
            { name: "vin", placeholder: "VIN", type: "text", required: true },
            { name: "dot_inspection_expiry", label: "DOT Inspection Expiry (optional)", type: "date" },
            { name: "dot_inspection_file", type: "file" },
            { name: "cab_card_expiry", label: "Cab Card Expiry (optional)", type: "date" },
            { name: "cab_card_file", type: "file" },
            { name: "notify_me", type: "checkbox", label: "Notify me 30 days before expiry" },
        ],
        trailer: [
            { name: "make", placeholder: "Make", type: "text", required: true },
            { name: "model", placeholder: "Model", type: "text", required: true },
            { name: "year", placeholder: "Year", type: "number", required: true },
            { name: "vin", placeholder: "VIN", type: "text", required: true },
            { name: "dot_inspection_expiry", label: "DOT Inspection Expiry (optional)", type: "date" },
            { name: "dot_inspection_file", type: "file" },
            { name: "notify_me", type: "checkbox", label: "Notify me 30 days before expiry" },
        ],
    };


    console.log('asd', isEdit)

    return (
        <Modal show={true} onHide={handleClose} centered size="lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Create Tractors & Trailers</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Body>
                    <Form.Label className="fw-semibold">Select Asset Type</Form.Label>
                    <div className="d-flex gap-3 mb-3">
                        <Button
                            variant={assetType === "tractors" ? "primary" : "outline-primary"}
                            onClick={() => setAssetType("tractors")}
                            type="button"
                        >
                            Tractors
                        </Button>
                        <Button
                            variant={assetType === "trailer" ? "primary" : "outline-primary"}
                            onClick={() => setAssetType("trailer")}
                            type="button"
                        >
                            Trailer
                        </Button>
                    </div>

                    <div className="d-flex flex-column gap-3">
                        {formFields?.[assetType]?.map((field, index) => (
                            <div key={index}>
                                <Controller
                                    name={field.name}
                                    control={control}
                                    rules={{ required: field.required ? true : false }}
                                    render={({ field: controllerField }) => {
                                        if (field.type === "checkbox") {
                                            return (
                                                <>
                                                    {/*{controllerField?.value}, {field.name}*/}
                                                    <Form.Check
                                                        {...controllerField}
                                                        type="checkbox"
                                                        label={field.label}
                                                        checked={!!controllerField.value}
                                                        isInvalid={!!errors[field.name]}
                                                    />
                                                </>
                                            );
                                        }
                                        if (field.type === "file") {
                                            return (
                                                <>
                                                    <Form.Control
                                                        type="file"
                                                        onChange={(e) => controllerField.onChange(e.target.files[0])}
                                                        isInvalid={!!errors[field.name]}
                                                    />
                                                    {isEdit?.[field?.name] && (
                                                        <a href={FILE_URL + isEdit?.[field?.name]} target="_blank" rel="noreferrer" className="px-1">
                                                            View Current File
                                                        </a>
                                                    )}
                                                </>

                                            );
                                        }
                                        return (
                                            <>
                                                {field.label && (
                                                    <Form.Label className="fw-semibold">{field.label}</Form.Label>
                                                )}
                                                <Form.Control
                                                    {...controllerField}
                                                    type={field?.type}
                                                    placeholder={field?.placeholder}
                                                    isInvalid={!!errors?.[field?.name]}
                                                />
                                            </>
                                        );
                                    }}
                                />
                                {errors[field.name] && (
                                    <Form.Text className="text-danger">
                                        {errors[field.name].message}
                                    </Form.Text>
                                )}
                            </div>
                        ))}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} type="button">
                        Cancel
                    </Button>
                    <LoadingButtonWithForm
                        className="btn btn-primary"
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                    />
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
